import config from '../views/mindset/config/mindset_api';
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';

const _pathUri = new PathUri(config.port, config.context);

export const service = {
  getListMindsets: () => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/empresas/marcas-empresariales/`,
      headers: {
        'idEmpresa': sessionStorage.getItem("idEmpresa"),
        'idUsuario': sessionStorage.getItem("idUsuario")
      },
    })
  },
  postCreateMindset: (formdata) => {  
    return axios({
      method: 'post',
      url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup") + '/empresas/crear/marcaempresarial'}`,
      headers: {
        'idEmpresa': sessionStorage.getItem("idEmpresa"),
        'idUsuario': sessionStorage.getItem("idUsuario")
      },
      data: formdata,
      redirect: 'follow'
    })
  },
  putUpdateMindset: (formdata) => {
    return axios({
      method: 'put',
      url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup") + '/empresas/actualizar/marcaempresarial'}`,
      headers: {
        'idEmpresa': sessionStorage.getItem("idEmpresa"),
        'idUsuario': sessionStorage.getItem("idUsuario")
      },
      data: formdata,
      redirect: 'follow'
    })
  },
}